import { render, staticRenderFns } from "./BuyChapterPackModal.vue?vue&type=template&id=23c3b789&scoped=true&"
import script from "./BuyChapterPackModal.vue?vue&type=script&lang=js&"
export * from "./BuyChapterPackModal.vue?vue&type=script&lang=js&"
import style0 from "./BuyChapterPackModal.vue?vue&type=style&index=0&id=23c3b789&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3b789",
  null
  
)

export default component.exports